import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { formatNumber, t } from 'ember-intl';

interface HotelOverviewDashboardSettingsAlertDaysIndicatorSignature {
  Args: {
    count: unknown;
    isLoading: unknown;
    thresholdValue: unknown;
    translationKey: unknown;
  };
}

const HotelOverviewDashboardSettingsAlertDaysIndicator = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class="alert-day-indicator-wrapper text-200--regular flex items-center">
    {{#if @isLoading}}
      <PrismLoadingBar />
    {{else}}
      {{#if @thresholdValue}}
        {{! We pass htmlSafe=true to the t helper here because the thresholdValue can be a rate formatted by the rates service functions }}
        {{! That can contain HTML entities (see formatValue). This flag makes sure it's rendered correctly }}
        {{t
          @translationKey
          count=(formatNumber @count)
          htmlSafe=true
          thresholdValue=@thresholdValue
        }}
      {{else}}
        {{t
          @translationKey
          count=(t "general.missing")
          thresholdValue=(t "general.missing")
        }}
      {{/if}}
    {{/if}}
  </div>
</template> satisfies TOC<HotelOverviewDashboardSettingsAlertDaysIndicatorSignature>;

export default HotelOverviewDashboardSettingsAlertDaysIndicator;
